import React from 'react'
import { Link } from 'react-router-dom';



const ViewAuditorium = () => {
  return (
    <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-lg-12 mb-4 order-0">
                        <div className="card card_wredb">
                            <div className='user_name_add'>
                                <h5 className="card-header card_hed_user">Auditorium Details</h5>

                                <Link to="/admin/auditorium" className='user_list_add'>
                                    <button type="button" class="btn btn-primary add_user_btn_bar">
                                        <i class="fa fa-arrow-right" aria-hidden="true"></i>&nbsp;Back
                                    </button>
                                </Link>
                            </div>
                            <div class="card-body pt-0">
                            <div className="table-responsive text-nowrap">
                                <table className="table table-bordered">
                                    <thead className=''>
                                        <tr>
                                            <th className="">Name</th>
                                            <td>Albert Cook</td>
                                        </tr>
                                    </thead>
                                    <tbody className="table-border-bottom-0">
                                        <tr>
                                            <th>Status</th>
                                            <td>Active</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}

export default ViewAuditorium;
